
import { useSelector } from "react-redux";
import { Card, Table, Spin } from "antd";
import { useGetAngelonePositionQuery } from "../slices/angelOneApiSlice";
import "./css/Dashboard.css";
import { useGetLoginUserQuery } from "../slices/usersApiSlice";

const PositionScreen = () => {
  const { darkmode } = useSelector((state) => state.darkmode);
  const { userInfo } = useSelector((state) => state.auth);
  const userId = userInfo?._id;
  const { data, isLoading, error } = useGetAngelonePositionQuery(userId);



  console.log("Raw API response:", data);

  // ✅ use positions array directly
  const positionsData = data?.positions || [];

  // ✅ map and include netqty
  const processedPositions = positionsData.map((pos, index) => {
    const ltp = parseFloat(pos.ltp ?? 0);
    const close = parseFloat(pos.close ?? 0);

    return {
      key: index,
      tradingsymbol: pos.tradingsymbol,
      exchange: pos.exchange,
      netqty: parseInt(pos.netqty ?? 0, 10), // <-- using netqty
      buyavg: parseFloat(pos.buyavgprice ?? 0),
      sellavg: parseFloat(pos.sellavgprice ?? 0),
      ltp,
      close,
      pnl: parseFloat(pos.pnl ?? 0),
      realised: parseFloat(pos.realised ?? 0),
      unrealised: parseFloat(pos.unrealised ?? 0),
    };
  });

  // ✅ define columns
  const positionsColumns = [
    { title: "Symbol", dataIndex: "tradingsymbol", key: "symbol" },
    { title: "Exchange", dataIndex: "exchange", key: "exchange" },
    {
      title: "Net Qty",
      dataIndex: "netqty",
      key: "netqty",
      render: (value) => (
        <span style={{ color: value >= 0 ? "#e9c46a" : "#8e9196" }}>{value}</span>
      ),
    },
    { title: "Buy Avg", dataIndex: "buyavg", key: "buyavg" },
    { title: "Sell Avg", dataIndex: "sellavg", key: "sellavg" },
    { title: "Close", dataIndex: "close", key: "close" },
    { title: "LTP", dataIndex: "ltp", key: "ltp" },
    {
      title: "PnL",
      dataIndex: "pnl",
      key: "pnl",
      render: (value) => (
        <span style={{ color: value >= 0 ? "#e9c46a" : "#8e9196" }}>₹{value}</span>
      ),
    },
    {
      title: "Realised",
      dataIndex: "realised",
      key: "realised",
      render: (value) => (
        <span style={{ color: value >= 0 ? "#e9c46a" : "#8e9196" }}>₹{value}</span>
      ),
    },
    {
      title: "Unrealised",
      dataIndex: "unrealised",
      key: "unrealised",
      render: (value) => (
        <span style={{ color: value >= 0 ? "#e9c46a" : "#8e9196" }}>₹{value}</span>
      ),
    },
  ];

  return (
    <Card
      title="Positions"
      bordered={false}
      className="card_hover"
      style={{
        backgroundColor: darkmode ? "#1f1f1f" : "#fff",
        width: "100%",
        overflowX: "auto",
        height: "500px",
        marginTop: "30px",
      }}
    >
      {isLoading ? (
        <Spin />
      ) : (
        <Table
          dataSource={processedPositions}
          columns={positionsColumns}
          pagination={false}
          bordered
          scroll={{ x: "max-content" }}
        />
      )}
    </Card>
  );
};

export default PositionScreen;
